import { RouteObject } from "react-router-dom";
import MerchantsPage from "./merchants-page";
import AddMerchantPage from "./add-merchant/add-merchant-page";
import MidsPage from "./mids/mids-page";
import MidTransactionsPage from "./mid-transactions/mid-transactions-page";
import EditMerchantPage from "./edit-merchant/edit-merchant-page";
import MerchantGuard from "../merchant-guard";
import AddMidPage from "./add-mid/add-mid-page";
import EditMidPage from "./edit-mid/edit-mid-page";
import MultiMerchantUsersPage from "./multi-merchant-users/multi-merchant-users-page";

const merchantsRouter: RouteObject[] = [
    {
        path: '',
        element: <MerchantsPage />
    },
    {
        path: 'add-merchant',
        element:
            <MerchantGuard>
                <AddMerchantPage />
            </MerchantGuard>
    },
    {
        path: 'edit-merchant/:id',
        element:
            <MerchantGuard>
                <EditMerchantPage />
            </MerchantGuard>
    },
    {
        path: 'merchant/:id',
        element: <MidsPage />
    },
    {
        path: 'merchant/:id/add-mid',
        element:
            <MerchantGuard>
                <AddMidPage />
            </MerchantGuard>
    },
    {
        path: 'merchant/:id/edit-mid/:id',
        element:
            <MerchantGuard>
                <EditMidPage />
            </MerchantGuard>
    },
    {
        path: 'mid-transactions/:id',
        element: <MidTransactionsPage />
    },
    {
        path: 'multi-merchant-users',
        element:
            <MerchantGuard>
                <MultiMerchantUsersPage />
            </MerchantGuard>
    },

]

export default merchantsRouter;